// https://github.com/l2ig/jToast
jQuery(function($) {
	const base = 'gc-toasts';

	let toasts = 0;
	let manager = {
		ready: true,
		jobs: [],
		currentWorkingID: 0,
		addJob(job) {
			this.ready = false;
			job.type === "show" ? this.jobs.push({ text: job.text, args: job.args, type: "show" }) : this.jobs.push({ id: job.id, type: "hide" });
		},
		removeJob(id) {
			if (this.currentWorkingID === id) {
				this.ready = true;
			}
		},
	};

	window.showToast = function (text, { duration = 3000 } = {}) {
		const selectedToast = toasts;
		if (!manager.ready) {
			manager.addJob({ text: text, args: showToast.arguments[1], workingID: selectedToast, type: "show" });
			return;
		}
		manager.currentWorkingID = selectedToast;

		$(`.${base}`).append(`
			<div data-toast-id="${toasts}" class="${base}__toast">
				<span>${text}</span>
			</div>
		`);

		$(`.${base}__toast`).map((i) => {
			manager.ready = false;
			if (i !== selectedToast) {
				$(`.${base}__toast`).eq(i).animate({
					"margin-top": "+=" + parseInt($(`[data-toast-id="${selectedToast}"]`).height() + (15 * 2) + 15 + 5) + "px"
				}, 300);

				setTimeout(() => {
					manager.removeJob(selectedToast);
				}, 300);
			} else {
				setTimeout(() => {
					$(`.${base}__toast`).eq(i).animate({
						"margin-top": "25px"
					}, 300);

					setTimeout(() => {
						manager.removeJob(selectedToast);
					}, 300);
				}, 150);
			}
		});

		setTimeout(() => {
			$(`[data-toast-id="${selectedToast}"]`).animate({
				"margin-right": "-" + parseInt($(`[data-toast-id="${selectedToast}"]`).width() + (15 * 2) + 25 + 100) + "px"
			}, 300);

			if (selectedToast !== toasts) {
				$(`.${base}__toast`).map((i) => {
					if (i < selectedToast) {
						setTimeout(() => {
							$(`.${base}__toast`).eq(i).animate({
								"margin-top": "-=" + parseInt($(`[data-toast-id="${selectedToast}"]`).height() + (15 * 2) + 15 + 5) + "px"
							}, 300);
						}, 300);
					}
				});
			}

			setTimeout(() => {
				$(`[data-toast-id="${selectedToast}"]`).addClass("hidden");
			}, 300);
		}, duration);

		toasts++;
		return selectedToast;
	}
});